/* global window */
/* eslint react/no-danger: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import { getAppConfig } from '../../../helpers/utils';
import { getLocale } from '../../../i18n';
import messages from '../messages';
import css from '../index.scss';
import withModal from '../../../components/with-modal';
import Button from '../../button/index';
import { DARK, ICON_ONLY } from '../../button/variants';
import { Cross } from '../../../helpers/icon-dictionary';

const RollOverHelp = (props) => {
    const {
        downloadRolloverTemplate,
        downloadSchoolRollDataRollover,
        hideHelpModal,
        intl,
        isDownloadingSchoolRollData,
        isDownloadingTemplate,
        selectedProduct
    } = props;

    const config = getAppConfig();
    const help = config ? config.RolloverHelpContent : '';

    let someHtml = '';

    if (help !== '' && getLocale().substr(0, 2) === 'es' && JSON.parse(help).es) {
        someHtml = JSON.parse(help).es;
    } else if (help !== '' && JSON.parse(help).en) {
        someHtml = JSON.parse(help).en;
    } else {
        someHtml = help;
    }

    return (<div className={css.rollOverModal}>
        <div className={css.rollOverModalContent}>
            <div dangerouslySetInnerHTML={{ __html: someHtml }} />
            <Button
                containerClassName={css.rollOverModalCloseBtn}
                handleOnClick={hideHelpModal}
                icon={Cross}
                label={intl.formatMessage(messages.closeButton)}
                variant={ICON_ONLY} />
        </div>
        <div className={css.rollOverModalFooter}>
            <div className={css.rollOverModalFooterLeft}>
                <Button
                    disabled={isDownloadingTemplate}
                    handleOnClick={downloadRolloverTemplate}
                    label={intl.formatMessage(messages.downloadTemplateBtn)}
                    variant={DARK} />
                <Button
                    disabled={isDownloadingSchoolRollData}
                    handleOnClick={() => { downloadSchoolRollDataRollover(selectedProduct.id); }}
                    label={intl.formatMessage(messages.downloadSchoolDataBtn)}
                    variant={DARK} />
            </div>
            <div className={css.rollOverModalFooterRight}>
                <Button
                    handleOnClick={hideHelpModal}
                    label={intl.formatMessage(messages.closeButton)}
                    variant={DARK} />
            </div>
        </div>
    </div>);
};

RollOverHelp.propTypes = {
    downloadSchoolRollDataRollover: PropTypes.func,
    downloadRolloverTemplate: PropTypes.func,
    hideHelpModal: PropTypes.func,
    intl: intlShape.isRequired,
    isDownloadingSchoolRollData: PropTypes.bool,
    isDownloadingTemplate: PropTypes.bool,
    selectedProduct: PropTypes.object
};

const DownloadHelpIntl = injectIntl(styleable(css)(RollOverHelp));
export default withModal('isActive')(DownloadHelpIntl);



// WEBPACK FOOTER //
// ./app/components/roll-over/modals/help.js